<template>
  <div class="content">
    <template>
      <v-card
        :style="
          $vuetify.breakpoint.xs
            ? 'margin: 4px'
            : 'margin: 0 18px 0 18px'
        "
      >
        <base-loading v-if="!ready" />
        <div
          v-if="ready"
          :key="status"
        >
          <crud-list
            ref="crudListCotacao"
            v-model="atendimentos"
            :headers="headers"
            :slots="[
              'item.data_atendimento',
              'item.valor_subtotal',
              'item.valor_descontos',
              'item.valor_total',
            ]"
            :actions="actions"
            :sort-by="['status', 'data_atendimento', 'data_prevista_entrega']"
            :sort-desc="[false,true,true]"
            total-column
            show-expand
          >
            <template slot="datas">
              <v-col
                cols="6"
              >
                <data-field
                  v-model="data_inicial"
                  :label="'Data Inicial'"
                  :data-max="data_final"
                  @set="handleDataFilter()"
                />
              </v-col>
              <v-col
                cols="6"
              >
                <data-field
                  v-model="data_final"
                  :label="'Data Final'"
                  :data-min="data_inicial"
                  @set="handleDataFilter()"
                />
              </v-col>
            </template>
            <template v-slot:[`item.data_atendimento`]="{ item }">
              <span>{{ moment( item.data_atendimento ).format( "DD/MM/YYYY") }}</span>
            </template>
            <template v-slot:[`item.valor_subtotal`]="{ item }">
              <span>R$ {{ currencyFormatter(item.valor_subtotal || 0) }}</span>
            </template>
            <template v-slot:[`item.valor_descontos`]="{ item }">
              <span>R$ {{ currencyFormatter(item.valor_descontos || 0) }}</span>
            </template>
            <template v-slot:[`item.valor_total`]="{ item }">
              <span>R$ {{ currencyFormatter(item.valor_total || 0) }}</span>
            </template>
            <template v-slot:expanded-item="{ item }">
              <td
                v-if="item.itens_servicos.length || item.itens.length"
                :colspan="headers.length"
                style="padding-left: 30px; padding-top: 10px;"
              >
                <div style="max-height: 500px;overflow-y: auto;">
                  <div v-if="item.itens_servicos.length">
                    <v-simple-table
                      :height="$vuetify.breakpoint.xl ? '300' : '200'"
                      fixed-header
                      class="my-1 mt-2"
                      dense
                    >
                      <thead>
                        <tr>
                          <th class="text-left">
                            Serviços
                          </th>
                          <th class="text-center">
                            UN
                          </th>
                          <th class="text-right">
                            Quantidade
                          </th>
                          <th
                            class="text-right"
                          >
                            Valor Unitário (R$)
                          </th>
                          <th class="text-right">
                            Valor Bruto (R$)
                          </th>
                          <th class="text-right">
                            Valor Desconto (R$)
                          </th>
                          <th class="text-right">
                            Valor Líquido (R$)
                          </th>
                          <th class="text-left">
                            Observação
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="( prod, index ) in item.itens_servicos"
                          :key="index"
                        >
                          <td
                            class="text-left"
                            width="500"
                          >
                            {{ prod.codProduto + ' - ' + prod.produto.nome }}
                          </td>
                          <td
                            width="50"
                            class="text-center"
                          >
                            {{ prod.unidade_medida }}
                          </td>
                          <td
                            width="50"
                            class="text-right"
                          >
                            {{ prod.quantidade }}
                          </td>
                          <td
                            width="50"
                            class="text-right"
                          >
                            R$ {{ currencyFormatter( prod.valor_unitario ) }}
                          </td>
                          <td
                            width="50"
                            class="text-right"
                          >
                            R$ {{ currencyFormatter( prod.valor_subtotal ) }}
                          </td>
                          <td
                            width="50"
                            class="text-right"
                          >
                            R$ {{ currencyFormatter( prod.valor_desconto ) }}
                          </td>
                          <td
                            width="50"
                            class="text-right"
                          >
                            R$ {{ currencyFormatter(prod.valor_total) }}
                          </td>
                          <td
                            width="100"
                            class="text-left"
                          >
                            {{ prod.observacao }}
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>

                  <div v-if="item.itens.length">
                    <v-simple-table
                      :height="$vuetify.breakpoint.xl ? '300' : '200'"
                      fixed-header
                      class="my-1 mt-2"
                      dense
                    >
                      <thead>
                        <tr>
                          <th class="text-left">
                            Produtos
                          </th>
                          <th class="text-center">
                            UN
                          </th>
                          <th class="text-right">
                            Quantidade
                          </th>
                          <th class="text-right">
                            Valor Unitário (R$)
                          </th>
                          <th class="text-right">
                            Valor Bruto (R$)
                          </th>
                          <th class="text-right">
                            Valor Desconto (R$)
                          </th>
                          <th class="text-right">
                            Valor Líquido (R$)
                          </th>
                          <th class="text-left">
                            Observação
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="( prod, index ) in item.itens"
                          :key="index"
                        >
                          <td
                            class="text-left"
                            width="500"
                          >
                            {{ prod.codProduto + ' - ' + prod.produto.nome }}
                          </td>
                          <td
                            width="50"
                            class="text-center"
                          >
                            {{ prod.unidade_medida }}
                          </td>
                          <td
                            width="50"
                            class="text-right"
                          >
                            {{ currencyFormatter(prod.quantidade) }}
                          </td>
                          <td
                            width="50"
                            class="text-right"
                          >
                            R$ {{ currencyFormatter( prod.valor_unitario ) }}
                          </td>
                          <td
                            width="50"
                            class="text-right"
                          >
                            R$ {{ currencyFormatter( prod.valor_desconto ) }}
                          </td>
                          <td
                            width="50"
                            class="text-right"
                          >
                            R$ {{ currencyFormatter( prod.valor_subtotal ) }}
                          </td>
                          <td
                            width="50"
                            class="text-right"
                          >
                            R$ {{ currencyFormatter(prod.valor_total) }}
                          </td>
                          <td
                            width="100"
                            class="text-left"
                          >
                            {{ prod.observacao }}
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>
                </div>
              </td>
            </template>
            <template
              v-if="$store.getters.hasPermission('inserir_atendimento')"
              v-slot:btnCadastro
            >
              <v-col>
                <v-btn
                  color="primary"
                  rounded
                  class="text-none"
                  @click="exportarXLSX(null)"
                >
                  <v-icon
                    dark
                    left
                  >
                    mdi-file-excel
                  </v-icon>
                  Exportar XLSX
                </v-btn>
              </v-col>
              <v-col>
                <v-btn
                  block
                  class="text-none text-white"
                  color="primary"
                  title="Cadastrar"
                  rounded
                  @click="NOVA_ATENDIMENTO()"
                >
                  <v-icon
                    dark
                    left
                  >
                    mdi-file-plus
                  </v-icon>
                  Cadastrar
                </v-btn>
              </v-col>
            </template>
          </crud-list>
          <atendimento-dialog :bootstrap="bootstrap" />
        </div>
      </v-card>
    </template>
  </div>
</template>
<script>
  import store from '@/store'
  import AtendimentosStore, { BOOTSTRAP, DELETE_ATENDIMENTO, EDIT_ATENDIMENTO, HISTORICO_ATENDIMENTO, NOVA_ATENDIMENTO } from '@/store/modules/atendimentos'
  import AtendimentoStore, { CLOSE } from '@/store/modules/forms/atendimento'
  import JsPDF from 'jspdf'
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
  import { currencyFormatter, dateFormatter } from '../../utils/formatter'
  import { sortDateTime } from '../../utils/sorts'
  import AtendimentoDialog from './AtendimentoDialog.vue'
  import XLSX from 'xlsx'

  export default {
    components: {
      AtendimentoDialog,
    },
    props: {
      status: {
        type: String,
        default: '',
      },
      inicio: {
        type: String,
        default: '',
      },
      fim: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        currencyFormatter,
        dateFormatter,
        data_inicial: 'from',
        data_final: 'to',
        headers: [
          { text: '', sortable: false, groupable: false, value: 'data-table-expand' },
          { text: '', value: 'actions', sortable: false, groupable: false, width: '100' },
          { align: 'left', sortable: true, groupable: false, text: 'Número do Atendimento', value: 'atendimento_id', width: 'auto', report: true, styleReport: { halign: 'right' } },
          { align: 'left', sortable: true, groupable: false, text: 'Data', value: 'data_atendimento', width: 'auto', sort: sortDateTime, report: true, styleReport: { halign: 'center' }, styleXLSX: { type: 'date' } },
          { align: 'left', sortable: true, groupable: true, text: 'Produtor', value: 'nome_produtor', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: true, groupable: true, text: 'Fazenda', value: 'nome_fazenda', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: true, groupable: true, text: 'Técnico', value: 'tecnico.nome', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: true, groupable: true, text: 'Unidade de Negócio', value: 'unidadeNegocio.nome_fantasia', width: 'auto', floatingfilter: true },
          { align: 'end', sortable: true, groupable: false, floatingfilter: false, text: 'Valor Bruto', value: 'valor_subtotal', sum: 'Money', width: 'auto', report: true, styleReport: { halign: 'right' } },
          { align: 'end', sortable: true, groupable: false, floatingfilter: false, text: 'Valor Descontos', value: 'valor_descontos', sum: 'Money', width: 'auto', report: true, styleReport: { halign: 'right' } },
          { align: 'end', sortable: true, groupable: false, floatingfilter: false, text: 'Valor Líquido', value: 'valor_total', sum: 'Money', width: 'auto', report: true, styleReport: { halign: 'right' } },
          { align: 'left', sortable: true, groupable: false, text: 'Observação', value: 'observacao', width: 'auto' },
        ],
        actions: [
          {
            title: 'Editar Atendimento',
            color: 'info darken-3',
            click: item => this.EDIT_ATENDIMENTO(item),
            icon: 'mdi-pencil',
            permission: 'editar_atendimento',
          },
          {
            title: 'Deletar Atendimento',
            color: 'red darken-3',
            click: item => this.DELETE_ATENDIMENTO(item),
            icon: 'mdi-trash-can-outline',
            permission: 'editar_atendimento',
          },
        ].filter(({ permission }) => store.getters.hasPermission(permission) && store.state.user.roles[0].slug !== 'tecnico'),
      }
    },
    computed: {
      ...mapState('atendimentos', ['ready', 'atendimentos']),
      ...mapGetters(['hasPermission']),
    },
    created () {
      if (!this.$store.state.form.atendimento) { this.$store.registerModule(['form', 'atendimento'], AtendimentoStore) }
      if (!this.$store.hasModule('atendimentos')) { this.$store.registerModule('atendimentos', AtendimentosStore) }

      this.bootstrap()
    },
    methods: {
      ...mapActions('atendimentos', [BOOTSTRAP, EDIT_ATENDIMENTO, DELETE_ATENDIMENTO, HISTORICO_ATENDIMENTO, NOVA_ATENDIMENTO]),
      ...mapMutations('form/atendimento', [CLOSE]),
      handleDataFilter () {
        const data_i = this.data_inicial
        const data_f = this.data_final
        this.BOOTSTRAP({ data_inicial: data_i, data_final: data_f })
      },
      filterStatus (status) {
        const elemento = this.$refs.crudListCotacao.filters.status.indexOf(status)
        if (this.$refs.crudListCotacao.filters.status && elemento === -1) {
          this.$refs.crudListCotacao.filters.status.splice(0, this.$refs.crudListCotacao.filters.status.length)
          this.$refs.crudListCotacao.filters.status.push(status)
        } else {
          this.$refs.crudListCotacao.filters.status.splice(elemento, 1)
        }
      },

      exportarXLSX (dados) {
        const wb = XLSX.utils.book_new()
        const ws_data = []
        if (dados) {
          ws_data.push(
            [
              'Atendimento',
              'Técnico',
              'Origem',
              'Unidade de Negócio',
              'Fazenda',
              'Matricula Clube',
              'Matricula',
              'Produtor',
              'Observação',
            ],
          )
          ws_data.push(
            [
              dados.atendimento_id,
              dados.tecnico ? dados.tecnico.nome : 'Não possui Técnico atribuido',
              dados.Origem ? dados.Origem.descricao : '',
              dados.unidadeNegocio.cod_clube + ' - ' + dados.unidadeNegocio.nome_fantasia,
              dados.nome_fazenda,
              dados.cod_produtor_fornecedor,
              dados.nome_produtor,
              dados.observacao,
            ],
          )
          ws_data.push(['', '', '', ''])

          ws_data.push([
            'Código',
            'Descrição',
            'UN',
            'Quantidade',
            'Volume',
            'Preco Compra',
            'Frete Unitario',
            'Vlr Bruto',
            'Vlr. Liquido',
            'Observação',
          ])
          dados.itens.forEach(item => {
            ws_data.push([
              item.codProduto,
              item.nome_produto,
              item.unidade_medida,
              item.quantidade,
              item.volume,
              { v: item.valor_unitario, t: 'n' },
              { v: item.valor_subtotal, t: 'n' },
              { v: item.valor_total, t: 'n' },
              item.nome_fornecedor,
              item.observacao ? item.observacao : '',
            ])
          })
        } else {
          const registros = this.$refs.crudListCotacao.valueFiltered
          ws_data.push([
            'Número Atendimento',
            'Data Atendimento',
            'Nome Produtor',
            'Nome Fazenda',
            'Técnico',
            'Unidade de Negocio',
            'Código Produto',
            'Descrição Produto',
            'UN',
            'Quantidade',
            'Valor Unitário (R$)',
            'Valor Desconto (R$)',
            'Valor Bruto (R$)',
            'Valor Total Produto/Serviço (R$)',
            'Valor Total Venda (R$)',
            'Observação',
          ])
          if (registros.length > 0) {
            registros.forEach(atendimento => {
              if (atendimento.itens.length === 0 && atendimento.itens_servicos.length === 0) {
                ws_data.push([
                  atendimento.atendimento_id ? atendimento.atendimento_id : '',
                  { v: atendimento.data_atendimento, t: 'd' },
                  atendimento.nome_produtor ? atendimento.nome_produtor : '',
                  atendimento.nome_fazenda ? atendimento.nome_fazenda : '',
                  atendimento.tecnico ? atendimento.tecnico.nome : '',
                  atendimento.unidadeNegocio.cod_centro ? atendimento.unidadeNegocio.cod_centro + ' - ' + (atendimento.unidadeNegocio.nome_fantasia ? atendimento.unidadeNegocio.nome_fantasia : '') : '',
                  '',
                  '',
                  '',
                  '',
                  '',
                  '',
                  '',
                  '',
                  '',
                  atendimento.observacao ? atendimento.observacao : '',
                ])
              } else {
                atendimento.itens.forEach(item => {
                  ws_data.push([
                    atendimento.atendimento_id ? atendimento.atendimento_id : '',
                    { v: atendimento.data_atendimento, t: 'd' },
                    atendimento.nome_produtor ? atendimento.nome_produtor : '',
                    atendimento.nome_fazenda ? atendimento.nome_fazenda : '',
                    atendimento.tecnico ? atendimento.tecnico.nome : '',
                    atendimento.unidadeNegocio.cod_centro ? atendimento.unidadeNegocio.cod_centro + ' - ' + (atendimento.unidadeNegocio.nome_fantasia ? atendimento.unidadeNegocio.nome_fantasia : '') : '',
                    item.codProduto ? item.codProduto : '',
                    item.nome_produto ? item.nome_produto : '',
                    item.unidade_medida,
                    { v: item.quantidade, t: 'n' },
                    { v: item.valor_unitario, t: 'n' },
                    { v: item.valor_desconto, t: 'n' },
                    { v: item.valor_subtotal, t: 'n' },
                    { v: item.valor_total, t: 'n' },
                    { v: atendimento.valor_total, t: 'n' },
                    atendimento.observacao ? atendimento.observacao : '',
                  ])
                })
                atendimento.itens_servicos.forEach(item => {
                  ws_data.push([
                    atendimento.atendimento_id ? atendimento.atendimento_id : '',
                    { v: atendimento.data_atendimento, t: 'd' },
                    atendimento.nome_produtor ? atendimento.nome_produtor : '',
                    atendimento.nome_fazenda ? atendimento.nome_fazenda : '',
                    atendimento.tecnico ? atendimento.tecnico.nome : '',
                    atendimento.unidadeNegocio.cod_centro ? atendimento.unidadeNegocio.cod_centro + ' - ' + (atendimento.unidadeNegocio.nome_fantasia ? atendimento.unidadeNegocio.nome_fantasia : '') : '',
                    item.codProduto ? item.codProduto : '',
                    item.nome_produto ? item.nome_produto : '',
                    item.unidade_medida,
                    { v: item.quantidade, t: 'n' },
                    { v: item.valor_unitario, t: 'n' },
                    { v: item.valor_desconto, t: 'n' },
                    { v: item.valor_subtotal, t: 'n' },
                    { v: item.valor_total, t: 'n' },
                    { v: atendimento.valor_total, t: 'n' },
                    atendimento.observacao ? atendimento.observacao : '',
                  ])
                })
              }
            })
          }
        }

        const ws = XLSX.utils.aoa_to_sheet(ws_data)

        const colWidths = ws_data[0].map((_, colIndex) => ws_data.reduce((maxWidth, currentRow) => {
          const cellValue = currentRow[colIndex]
          const cellWidth = (typeof cellValue === 'string' ? cellValue.length : 0)
          return Math.max(maxWidth, cellWidth)
        }, 0))

        ws['!cols'] = colWidths.map(width => ({ wch: width + 2 }))
        XLSX.utils.book_append_sheet(wb, ws, 'Relatório')
        XLSX.writeFile(wb, 'Relatorio.xlsx')
      },

      async exportPDF (dados) {
        const spaceLine = 7
        const fontSize = 10
        const fontTitleSize = fontSize * 2
        const margin = { left: 10, right: 10, bottom: 10 }

        function getY (y) {
          if ((y + fontSize) > docHeight) {
            doc.addPage()
            i = 1
            return fontSize
          } else {
            return y
          }
        }

        function formataMoney (valor) {
          valor = valor.toFixed(2)
          valor = valor.toString()
          valor = valor.replace('.', ',')
          valor = valor.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
          return valor
        }

        function addFooter (pageNumber) {
          doc.setFontSize(fontSize - 1)
          doc.text(dateNow, margin.left - 5, docHeight - margin.bottom)
          doc.text('https://app.pioneiros.vet.br', docWidth / 2, docHeight - margin.bottom, { align: 'center' })
          doc.text('Página ' + pageNumber + ' / ' + totalPages, docWidth + 17, docHeight - margin.bottom, { align: 'right' })
        }
        function addHeader () {
          doc.addImage(window.location.origin + '/img/logo_branca.png', 'png', margin.left, 5, 52, 18)
          doc.setFontSize(fontTitleSize)
          doc.text('Atendimento', docWidth / 2, 15, { align: 'center' })
          doc.setFontSize(fontSize)
          doc.text('Data: ' + dateFormatter(dados.data_atendimento), docWidth - margin.right, getY(++i * spaceLine), { align: 'right' })
          //   doc.text(dados.status, docWidth / 2, getY(i * spaceLine), { align: 'center' })
          doc.line(margin.left, 24, docWidth - margin.right, 24)
          doc.autoTable({
            theme: 'plain',
            startY: 25,
            styles: { textColor: 20, fillColor: [255, 255, 255] },
            body: [
              [
                'Nº Atendimento: ' + dados.atendimento_id,
                'Técnico: ' + (dados.tecnico ? dados.tecnico.nome : 'Não possui Técnico atribuido'),
                'Unidade de Negócio: ' + dados.unidadeNegocio.cod_clube + ' - ' + dados.unidadeNegocio.nome_fantasia,
              ],
              [
                'Matricula: ' + dados.cod_produtor_fornecedor,
                'Produtor: ' + dados.nome_produtor,
              ],
              [
                'Matricula Clube: ' + dados.cod_produtor_cliente,
                'Fazenda: ' + dados.nome_fazenda,
                'Municipio: ' + dados.cidade_fazenda + ' - ' + dados.estado_fazenda,
              ],
            ],
            didParseCell: (data) => {
              if (data.row.index === 0) {
                data.cell.styles.cellPadding = { top: 1, right: 1.7638888888888886, bottom: 1, left: 1.7638888888888886 }
              } else {
                data.cell.styles.cellPadding = { top: 0.7, right: 1.7638888888888886, bottom: 1, left: 1.7638888888888886 }
              }
            },
          })
        }

        var doc = new JsPDF({
          orientation: 'landscape',
        })
        const dateNow = (new Date()).toLocaleString()
        const docWidth = doc.internal.pageSize.width
        const docHeight = doc.internal.pageSize.height
        var totalPages = '{total_pages_count_string}'
        var i = 2

        doc.autoTable({
          theme: 'plain',
          columnStyles: {
            desconto_negociado: { cellWidth: 21, halign: 'right' },
            preco_desconto: { halign: 'right' },
            quantidade: { halign: 'right' },
            volume: { halign: 'right' },
            valor_custo: { cellWidth: 22, halign: 'right' },
            valor_unitario: { cellWidth: 18, halign: 'right' },
            valor_subtotal: { cellWidth: 20, halign: 'right' },
            valor_total: { cellWidth: 22, halign: 'right' },
          },
          styles: { lineColor: [0, 0, 0], fontSize: 9 },
          headStyles: { lineWidth: { top: 0.2, right: 0, bottom: 0.2, left: 0 }, quantidade: { halign: 'right' } },
          columns: [
            { title: 'Código', dataKey: 'codProduto' },
            { title: 'Descrição', dataKey: 'nome_produto' },
            { title: 'UN', dataKey: 'unidade_medida' },
            { title: 'Qtd.', dataKey: 'quantidade' },
            { title: 'Vol.', dataKey: 'volume' },
            { title: 'Pr. Venda', dataKey: 'valor_unitario' },
            { title: 'Vlr Bruto', dataKey: 'valor_subtotal' },
            { title: 'Vlr. Liquido', dataKey: 'valor_total' },
            { title: 'Fornecedor', dataKey: 'nome_fornecedor' },
          ],
          body: dados.itens,

          margin: { top: 43, left: 10, right: 10, bottom: 10 },
          didParseCell: (data) => {
            const trocarPonto = data.column.dataKey === 'valor_unitario' ||
              data.column.dataKey === 'valor_subtotal' ||
              data.column.dataKey === 'valor_custo' ||
              data.column.dataKey === 'valor_total' ||
              data.column.dataKey === 'margem_lucro' ||
              data.column.dataKey === 'icms' ||
              data.column.dataKey === 'valor_unit_frete' ||
              data.column.dataKey === 'valor_unitario_referencial'
            if (trocarPonto) {
              data.cell.styles.halign = 'right'
              if (data.row.section === 'body' && data.cell.text) {
                data.cell.text = formataMoney(parseFloat(data.cell.text))
              }
            }
          },

          willDrawPage: () => {
            addHeader()
          },
          didDrawPage: (data) => {
            addFooter(data.pageNumber)
          },

        })
        let finalY = doc.lastAutoTable.finalY
        doc.setFontSize(fontSize)
        doc.setFont('helvetica', 'normal')
        const observacao = dados.observacao ? dados.observacao : ''
        doc.text('Observação: ' + observacao, margin.left + 2, finalY += 6, { maxWidth: 220 })

        if (observacao.length > 255) {
          finalY += 10
        }

        if (finalY > 140) {
          doc.addPage()
          addHeader()
          finalY = 43
          doc.line(margin.left, finalY, docWidth - margin.right, finalY)
        }
        if (typeof doc.putTotalPages === 'function') {
          doc.putTotalPages(totalPages)
        }
        doc.save('atendimento_' + dados.atendimento_id + '.pdf')
      },

      bootstrap () {
        if (this.inicio && this.fim) {
          this.data_inicial = this.inicio
          this.data_final = this.fim
          this.BOOTSTRAP({ data_inicial: this.inicio, data_final: this.fim })
          return
        }

        const now = new Date()
        const data_i = new Date(now.getFullYear(), now.getMonth() - 2, 1)
        const data_f = new Date(now.getFullYear(), now.getMonth() + 1, 0)

        this.data_inicial = data_i.toISOString().slice(0, 10)
        this.data_final = data_f.toISOString().slice(0, 10)

        this.BOOTSTRAP({ data_inicial: data_i.toISOString().slice(0, 10), data_final: data_f.toISOString().slice(0, 10) })
      },
    },
  }
</script>
<style scoped>
.hide-sort-icon ::v-deep .v-data-table-header__icon,
.no-sort-column ::v-deep .v-data-table-header__icon {
  display: none !important;
}
</style>
